import React, { useEffect, useState } from "react";
import axiosInstance from "../../Api/axios.instance";

const drilldownMap = {
  //1: 47, // Schools
  1: 140, // Students
  2: 147, // Parents
  3: 43, // Orphan
  4: 172, // Zakat Deserving
  5: 316, //Missing CNIC
  6: 141, // Principal
  7: 45, // Teachers
  8: 142, // Non-Teaching
  9: 269, // Teacher Observation
 10: 144, // Admissions
 11: 143, // Dropouts
 12: 349,  // Tasks by school
 13: 626, // Assets Purchased
 14: 627, // Damaged Assets
 15: 629, // Soft Board
 16: 631, // Water Electric Cooler
 17: 640, // School Without Power Backup
 18: 633,// School With more than 1 Backup
 19: 635,// Total Surplus / Deficit Student Chairs
 20: 637,// Total Surplus /  Deficit staff Tables
 21: 615,// School Grade - QIP
 22: 484,// School Building and Infrastructure
 23: 482,// Classroom Grade
 24: 483,// Washroom Grading
 25: 49,  // Students by Gender
 26: 146  // Students by Class
};

const cardPositions = {
  1: { top: "2.9%", left: "1.9%", width: "23.8%", height: "9.5%" },   // Students Previous Schools
  2: { top: "2.9%", left: "26%", width: "23.8%", height: "9.5%" },    // Parents
  3: { top: "2.9%", left: "50%", width: "23.8%", height: "9.5%" },  // Orphans
  4: { top: "2.9%", left: "74%", width: "23.8%", height: "9.5%" },    // Zakat Deserving

  5: { top: "12.6%", left: "1.9%", width: "23.8%", height: "9.5%" },  // Missing CNIC
  6: { top: "12.6%", left: "26%", width: "23.8%", height: "9.5%" },   // Principal
  7: { top: "12.6%", left: "50%", width: "23.8%", height: "9.5%" }, // Teachers
  8: { top: "12.6%", left: "74%", width: "23.8%", height: "9.5%" },   // Non-Teaching

  9: { top: "22.4%", left: "1.9%", width: "23.8%", height: "9.5%" },  // Teacher Observation
 10: { top: "22.4%", left: "26%", width: "23.8%", height: "9.5%" },   // Admission From July
 11: { top: "22.4%", left: "50%", width: "23.8%", height: "9.5%" }, // Dropout From July
//  12: { top: "22.4%", left: "74%", width: "23.8%", height: "9.5%" }, // Tasks by school

 13: { top: "35.5%", left: "1.9%", width: "23.8%", height: "9.5%" }, // Assets Purchased
 14: { top: "35.5%", left: "26%", width: "23.8%", height: "9.5%" }, // Damaged Assets
 15: { top: "35.5%", left: "50%", width: "23.8%", height: "9.5%" }, // Soft Board
 16: { top: "35.5%", left: "74%", width: "23.8%", height: "9.5%" }, // Water Electric Cooler

 17: { top: "45.3%", left: "1.9%", width: "23.8%", height: "9.5%" }, // School Without Power Backup
 18: { top: "45.3%", left: "26%", width: "23.8%", height: "9.5%" }, // School With more than 1 Backup
 19: { top: "45.3%", left: "50%", width: "23.8%", height: "9.5%" }, // Total Surplus / Deficit Student Chairs
 20: { top: "45.3%", left: "74%", width: "23.8%", height: "9.5%" }, // Total Surplus /  Deficit staff Tables

 21: { top: "58.37%", left: "1.9%", width: "23.8%", height: "9.5%" }, // School Grade - QIP
 22: { top: "58.37%", left: "26%", width: "23.8%", height: "9.5%" }, // School Building and Infrastructure
 23: { top: "58.37%", left: "50%", width: "23.8%", height: "9.5%" }, // Classroom Grade
 24: { top: "58.37%", left: "74%", width: "23.8%", height: "9.5%" }, // Washroom Grading
 
 25: { top: "68.2%", left: "1.84%", width: "44%", height: "19.5%" }, // Students By Gender 
 26: { top: "68.2%", left: "46%", width: "52%", height: "19.5%" } // Students By Gender 
};


const Metabase = ({ cluster, school }) => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [mode, setMode] = useState("dashboard"); // 'dashboard' or 'question'

  useEffect(() => {
    loadDashboard();
  }, [cluster, school]);

  const loadDashboard = () => {
    axiosInstance
      .get("/metabase/dashboard", { params: { cluster, school } })
      .then((res) => {
        setIframeUrl(res.data.url);
        setMode("dashboard");
      });
  };

  const loadDrilldown = (cardId) => {
    const questionId = drilldownMap[cardId];
    if (!questionId) return;

    axiosInstance.get(`/metabase/question/${questionId}`, {
    params: { cluster, school }
    }).then((res) => {
        setIframeUrl(res.data.url);
        setMode("question");
      });
  };
  
  return (
    <div style={{ position: "relative" }}>
      {iframeUrl ? (
        <>
          <iframe
            src={iframeUrl}
            frameBorder="0"
            width="100%"
            height={1400}
            allowTransparency
            title="Metabase"
          />
          {mode === "dashboard" &&
            Object.entries(cardPositions).map(([cardId, pos]) => (
              <div
                key={cardId}
                onClick={() => loadDrilldown(cardId)}
                style={{
                  position: "absolute",
                  ...pos,
                  zIndex: 10,
                  cursor: "pointer",
                }}
              />
            ))}
          {mode === "question" && (
            <button
              onClick={loadDashboard}
              style={{
                position: "absolute",
                top: 8,
                right: 16,
                zIndex: 20,
                backgroundColor: "#0072BB", 
                color: "white",
                padding: "8px 16px",
                fontSize: "10px",
                fontWeight: "500",
                border: "none",
                borderRadius: "6px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                cursor: "pointer",
              }}
            >
              ← Back to Dashboard
            </button>
          )}
        </>
      ) : (
        <p>Loading dashboard...</p>
      )}
    </div>
  );
};

export default Metabase;
// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../Api/axios.instance";

// const drilldownMap = {
//   1: 47, 2: 140, 3: 147, 4: 43,
//   5: 172, 6: 141, 7: 45, 8: 142,
//   9: 269, 10: 144, 11: 143, 12: 49, 13: 146,
// };

// const getCardGrid = (cardId) => {
//   const map = {
//     1: { row: "1", col: "1" },
//     2: { row: "1", col: "2" },
//     3: { row: "1", col: "3" },
//     4: { row: "1", col: "4" },
//     5: { row: "2", col: "1" },
//     6: { row: "2", col: "2" },
//     7: { row: "2", col: "3" },
//     8: { row: "2", col: "4" },
//     9: { row: "3", col: "1" },
//     10: { row: "3", col: "2" },
//     11: { row: "3", col: "3" },
//     12: { row: "4 / span 2", col: "1 / span 2" }, // spans 2 columns
//     13: { row: "4 / span 2", col: "3 / span 2" },
//   };
//   return map[cardId] || { row: "1", col: "1" };
// };

// const Metabase = ({ cluster, school }) => {
//   const [iframeUrl, setIframeUrl] = useState("");
//   const [mode, setMode] = useState("dashboard");

//   useEffect(() => {
//     loadDashboard();
//   }, [cluster, school]);

//   const loadDashboard = () => {
//     axiosInstance.get("/metabase/dashboard", { params: { cluster, school } }).then((res) => {
//       setIframeUrl(res.data.url);
//       setMode("dashboard");
//     });
//   };

//   const loadDrilldown = (cardId) => {
//     const questionId = drilldownMap[cardId];
//     if (!questionId) return;
//     axiosInstance.get(`/metabase/question/${questionId}`, {
//       params: { cluster, school }
//     }).then((res) => {
//       setIframeUrl(res.data.url);
//       setMode("question");
//     });
//   };

//   return (
//     <div style={{ width: "100%", aspectRatio: "16/9", position: "relative" }}>
//       {iframeUrl ? (
//         <>
//           <iframe
//             src={iframeUrl}
//             style={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "1200px",
//               border: "none",
//             }}
//             allowTransparency
//             title="Metabase"
//           />
//           {mode === "dashboard" && (
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(4, 1fr)",
//                 gridTemplateRows: "repeat(5, 1fr)",
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 zIndex: 10,
//               }}
//             >
//               {Object.keys(drilldownMap).map((cardId) => {
//                 const { row, col } = getCardGrid(Number(cardId));
//                 return (
//                   <div
//                     key={cardId}
//                     onClick={() => loadDrilldown(Number(cardId))}
//                     style={{
//                       gridRow: row,
//                       gridColumn: col,
//                       cursor: "pointer",
//                     }}
//                   />
//                 );
//               })}
//             </div>
//           )}
//           {mode === "question" && (
//             <button
//               onClick={loadDashboard}
//               style={{
//                 position: "absolute",
//                 top: 8,
//                 right: 16,
//                 zIndex: 20,
//                 backgroundColor: "#0072BB",
//                 color: "white",
//                 padding: "8px 16px",
//                 fontSize: "10px",
//                 fontWeight: "500",
//                 border: "none",
//                 borderRadius: "6px",
//                 boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                 cursor: "pointer",
//               }}
//             >
//               ← Back to Dashboard
//             </button>
//           )}
//         </>
//       ) : (
//         <p>Loading dashboard...</p>
//       )}
//     </div>
//   );
// };

// export default Metabase;

// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../Api/axios.instance";

// const drilldownMap = {
//   1: 47, 2: 140, 3: 147, 4: 43,
//   5: 172, 6: 141, 7: 45, 8: 142,
//   9: 269, 10: 144, 11: 143, 12: 49, 13: 146,
// };

// // Define overlay card positions in percentages (relative to the iframe size)
// const cardPositions = {
//   1: { top: "4%", left: "1.5%", width: "24%", height: "16%" },   // Schools
//   2: { top: "4%", left: "26%", width: "24%", height: "16%" },    // Students
//   3: { top: "4%", left: "50.5%", width: "24%", height: "16%" },  // Parents
//   4: { top: "4%", left: "75%", width: "24%", height: "16%" },    // Orphans

//   5: { top: "21%", left: "1.5%", width: "24%", height: "15%" },  // Zakat Deserving
//   6: { top: "21%", left: "26%", width: "24%", height: "15%" },   // Principal
//   7: { top: "21%", left: "50.5%", width: "24%", height: "15%" }, // Teachers
//   8: { top: "21%", left: "75%", width: "24%", height: "15%" },   // Non-Teaching

//   9: { top: "37%", left: "1.5%", width: "24%", height: "15%" },  // Teacher Observation
//  10: { top: "37%", left: "26%", width: "24%", height: "15%" },   // Admission From July
//  11: { top: "37%", left: "50.5%", width: "24%", height: "15%" }, // Dropout From July
//  12: { top: "53%", left: "1.5%", width: "44%", height: "30%" }, // Students By Gender 
//  13: { top: "53%", left: "47%", width: "50%", height: "30%" } // Students By Gender 
// };

// const Metabase = ({ cluster, school }) => {
//   const [iframeUrl, setIframeUrl] = useState("");
//   const [mode, setMode] = useState("dashboard");

//   useEffect(() => {
//     loadDashboard();
//   }, [cluster, school]);

//   const loadDashboard = () => {
//     axiosInstance
//       .get("/metabase/dashboard", { params: { cluster, school } })
//       .then((res) => {
//         setIframeUrl(res.data.url);
//         setMode("dashboard");
//       });
//   };

//   const loadDrilldown = (cardId) => {
//     const questionId = drilldownMap[cardId];
//     if (!questionId) return;
//     axiosInstance.get(`/metabase/question/${questionId}`, {
//       params: { cluster, school },
//     }).then((res) => {
//       setIframeUrl(res.data.url);
//       setMode("question");
//     });
//   };

//   return (
//     <div style={{ width: "100%", maxWidth: "100%", position: "relative" }}>
//       {iframeUrl ? (
//         <div
//           style={{
//             position: "relative",
//             paddingTop: "56.25%", // 16:9 aspect ratio
//             width: "100%",
//             overflow: "hidden",
//           }}
//         >
//           <iframe
//             src={iframeUrl}
//             title="Metabase"
//             allowTransparency
//             style={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "1200px",
//               border: "none",
//             }}
//           />

//           {mode === "dashboard" &&
//             Object.entries(cardPositions).map(([cardId, style]) => (
//               <div
//                 key={cardId}
//                 onClick={() => loadDrilldown(Number(cardId))}
//                 style={{
//                   position: "absolute",
//                   ...style,
//                   zIndex: 10,
//                   cursor: "pointer",
//                 }}
//               />
//             ))}

//           {mode === "question" && (
//             <button
//               onClick={loadDashboard}
//               style={{
//                 position: "absolute",
//                 top: 8,
//                 right: 16,
//                 zIndex: 20,
//                 backgroundColor: "#0072BB",
//                 color: "white",
//                 padding: "8px 16px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 border: "none",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//               }}
//             >
//               ← Back to Dashboard
//             </button>
//           )}
//         </div>
//       ) : (
//         <p>Loading dashboard...</p>
//       )}
//     </div>
//   );
// };

// export default Metabase;
